import { crmSystem } from "@/constants/crm/_shared/systems";
import { ParameterInputEvent } from "@/features/crm_system/lib/crm/_common/ConfigurationParameterInput";
import { QuestionFormSchemaType } from "@/features/question/components/organisms/QuestionForm";
import { FullConfiguration } from "@/types/crm/configuration/configuration";
import { FullParameterData } from "@/types/crm/configuration/parameter";
import { UseFormReturn } from "react-hook-form";
import { ConfigurationParameterInput } from "./ConfigurationParameterInput";

interface QuestionConfigurationParameterInputProps {
    crmSystem: crmSystem | undefined | null;
    parameters: FullParameterData[];
    form: UseFormReturn<QuestionFormSchemaType>;
    fullConfiguration: FullConfiguration;
    handleEvent?: (event: ParameterInputEvent) => void;
}

export function QuestionConfigurationParameterInput({
    crmSystem,
    parameters,
    form,
    fullConfiguration,
    handleEvent
}: Readonly<QuestionConfigurationParameterInputProps>) {
    const values = parameters.map((_, i) =>
        form.watch(`selected_configuration.parameter.${i}.value`) ?? undefined
    );
    
    const handleChange = (index: number, value: string | null | undefined) => {
        form.setValue(`selected_configuration.parameter.${index}.value`, value);
        form.setValue(`selected_configuration.parameter.${index}.id`, parameters[index]?.id);
    };
    


    return (
        <ConfigurationParameterInput
            crmSystem={crmSystem}
            parameters={parameters}
            values={values}
            onChange={handleChange}
            fullConfiguration={fullConfiguration}
            onEvent={handleEvent}
        />
    );
}